<template>
    <div :style="headerStyles">
        <h1>{{ title }}</h1>
    </div>
</template>

<script>import script from './pageHeader';
    export default script;</script>

<style lang="less" scoped>
    div {
        color: #fff;
        text-align: center;
        width: 100%;
        height: 75px;
        background: var(--bg_462);
    }

    h1 {
        margin: 0;
        padding-top: 0.5em;
        text-shadow: -1.5px 1.5px #000;
    }

    @media (min-width: 469px) {
        div {
            background: var(--bg_750);
        }
    }

    @media (min-width: 769px) {
        div {
            background: var(--bg_942);
        }
    }

    @media (min-width: 961px) {
        div {
            background: var(--bg_1202);
        }
    }

    @media (min-width: 1221px) {
        div {
            background: var(--bg_1910);
        }
    }

    @media (min-width: 1921px) {
        div {
            background: var(--bg_2550);
        }
    }
</style>
